import axios from 'axios';
import { message } from 'antd';

const service = axios.create({
  timeout: 5000,
  baseURL: process.env.REACT_APP_API_BASE
});

service.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8';

service.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token !== 'undefined') {
      config.headers.Authorization = `${token}`;
    }
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // } else {
    //   return message.error('miss token');
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const { data } = response;

    if (data.code === '30000') {
      message.error(data.msg);

      localStorage.removeItem('user');
      localStorage.removeItem('token');
      
      setTimeout(function(){
        window.location.href = '/login?redirect_url='+window.location.pathname;
      },300);
      // window.location.href = '/login?redirect_url='+window.location.pathname;
      // return message.error(data.message ? data.message : data.msg);
    }

    if(data.code === '20000') {
        const msg = data.message ?? data.msg
      if (msg) message.error(msg);
      return data;
    }else{
        return data;
    }
    
    // return data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
